import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

/** Définitions de champs personnalisés actives pour une entité (clients, contacts, products…). */
export function useCustomFieldDefinitions(entity: string) {
  return useQuery({
    queryKey: ["custom_field_definitions", entity],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("custom_field_definitions").select("*")
        .eq("entity", entity).eq("is_active", true).order("position");
      if (error) throw error;
      return data;
    },
    staleTime: 5 * 60_000,
  });
}
